import React, { ReactNode } from "react"
import RadioButtons from "components/ReactHookForm/RadioButtons"
import { Control, FieldValues } from "react-hook-form"
import {
  Box, FormLabel, Text,
} from "@chakra-ui/react"
import { Boolean } from "utilities/enums"

type Props<T extends FieldValues> = {
  control: Control<T, object>
  sendConfirmationEmails: boolean
}

const EmailConfirmation = <T extends FieldValues, >({
  control,
  sendConfirmationEmails,
}: Props<T>) => {
  const guestCreationOptions = [
    {
      label: "Use Event Default",
      value: Boolean.False,
      additionalElement: (
        <AdditionalElementWrapper>
          <Text fontSize="sm">Currently: {sendConfirmationEmails ? "Enabled" : "Disabled"}</Text>
        </AdditionalElementWrapper>
      ),
    },
    {
      label: "Disable",
      value: Boolean.True,
      additionalElement: (
        <AdditionalElementWrapper>
          <Text fontSize="sm">Do not send a confirmation email when this form is submitted.</Text>
        </AdditionalElementWrapper>
      ),
    },
  ]

  return (
    <Box>
      <FormLabel fontWeight="semibold" mb={3}>Email Confirmation</FormLabel>
      <RadioButtons
        name="confirmationEmailsDisabled"
        control={control}
        options={guestCreationOptions}
        spacing={7}
        alignItems="center"
      />
    </Box>
  )
}

const AdditionalElementWrapper = ({ children }: {children: ReactNode}) => <Box w="full" pl={7} mt={-6}>{children}</Box>

export default EmailConfirmation
